<div *ngIf="loading">
    <div class="absolute fa fa-fw fa-pulse fa-spinner left-50 text-7xl top-50"></div>
</div>